import { render } from "./TopBoard.vue?vue&type=template&id=54c4d6b0"
const script = {}

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__